module.exports = __webpack_public_path__ + "static/img/right-bottom-corner.a38221fc.png";